import { useSuspenseQuery } from '@tanstack/react-query';
import { Box } from '@givebutter/primitives/box';
import { pluralize } from '@givebutter/util';
import { faCircleCheck, faTablePicnic, faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fetchTableSeatingStats } from 'api/events';
import { useCurrentCampaignEvent } from 'customHooks/useCurrentCampaignEvent';
import { eventQueryKeys } from 'queries/event-query-keys';

const TableSeatingStats = () => {
    const { data: event } = useCurrentCampaignEvent();
    const { data: stats } = useSuspenseQuery({
        queryKey: eventQueryKeys.tableSeatingStats(event.id),
        queryFn: () => fetchTableSeatingStats(event.id),
    });

    return (
        <div className="flex flex-wrap items-center gap-4">
            <Box className="flex items-center gap-2 rounded-full px-4 py-2">
                <FontAwesomeIcon
                    size="lg"
                    icon={faTablePicnic}
                    className="text-blue-500"
                    aria-hidden="true"
                />
                <div className="flex items-center gap-1 whitespace-nowrap text-sm">
                    <span className="font-medium">{stats.seating.groups}</span>
                    <span className="text-xs text-gray-600">
                        {pluralize(stats.seating.groups, 'Table')}
                    </span>
                </div>
            </Box>
            <Box className="flex items-center gap-2 rounded-full px-4 py-2">
                <FontAwesomeIcon
                    size="sm"
                    icon={faUser}
                    className="text-violet-500"
                    aria-hidden="true"
                />
                <div className="flex items-center gap-1 whitespace-nowrap text-sm">
                    <span className="font-medium">
                        {stats.tickets.total - stats.tickets.unseated}
                    </span>
                    <span className="text-xs font-medium text-gray-500">of</span>
                    <span className="font-medium">{stats.tickets.total}</span>
                    <span className="text-xs text-gray-600">
                        {pluralize(stats.seating.seats, 'Seat')} assigned
                    </span>
                </div>
            </Box>
            <Box className="flex items-center gap-2 rounded-full px-4 py-2">
                <FontAwesomeIcon
                    size="sm"
                    icon={faCircleCheck}
                    className="text-green-500"
                    aria-hidden="true"
                />
                <div className="flex items-center gap-1 whitespace-nowrap text-sm">
                    <span className="font-medium">{stats.tickets.checked_in}</span>
                    <span className="text-xs font-medium text-gray-500">of</span>
                    <span className="font-medium">{stats.tickets.total}</span>
                    <span className="text-xs text-gray-600">
                        {pluralize(stats.tickets.total, 'Guest')} checked-in
                    </span>
                </div>
            </Box>
        </div>
    );
};

export { TableSeatingStats };
